var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { attachKey2click, SurveyElementBase, SvgIcon } from "survey-react-ui";
var TabButtonComponent = /** @class */ (function (_super) {
    __extends(TabButtonComponent, _super);
    function TabButtonComponent(props) {
        return _super.call(this, props) || this;
    }
    TabButtonComponent.prototype.getStateElement = function () {
        return this.props.model;
    };
    TabButtonComponent.prototype.renderElement = function () {
        var model = this.props.model;
        if (!model.visible)
            return null;
        var button = attachKey2click(React.createElement("div", { className: model.buttonClassName, title: model.tooltip, onClick: function () { model.action(); } },
            React.createElement("div", { className: "svc-menu-action__icon" },
                React.createElement("div", { className: "svc-menu-action__icon-container" },
                    React.createElement(SvgIcon, { iconName: model.iconName, size: "auto" })))), model);
        return (React.createElement("div", { className: "svc-menu-action" }, button));
    };
    return TabButtonComponent;
}(SurveyElementBase));
export { TabButtonComponent };
